import debounceObservation from './debounce-observation';

let observer;
const debounceObservation2 = debounceObservation((el) => {
  // if ('isIntersecting' in el.dataset) {
  el.classList.add('fade-in_in');
  if (el.dataset.noUnobserve === undefined) {
    observer.unobserve(el);
  }
  // }
}, (el) => {
  if ('noUnobserve' in el.dataset) {
    el.classList.remove('fade-in_in');
  }
});

observer = new IntersectionObserver((entries) => {
  entries.forEach(debounceObservation2);
}, { threshold: 0, rootMargin: '0px 0px -80px' });

export default function (container) {
  if (window.isMobile.any) return;
  const elements = container.querySelectorAll('[data-fade-in], .subtitle:not([data-no-fade-in]), [data-fade-in-parent] > *');
  observer.disconnect();
  elements.forEach((element) => {
    element.classList.add('fade-in');
    observer.observe(element);
  });
}
